import { FaAward } from "react-icons/fa";
import { FaThumbsUp } from "react-icons/fa"; //TbBooks
import { BiHappyHeartEyes } from "react-icons/bi";

const AboutDataLink = [
  {
    id: 1,
    icon: <FaAward />,
    title: "Experience",
    description: "3+ years Working",
  },

  {
    id: 2,
    icon: <FaThumbsUp />,
    title: "Projects",
    description: "50 Completed",
  },

  {
    id: 3,
    icon: <BiHappyHeartEyes />,
    title: "Clients",
    description: "Happy clients",
  },
];

export default AboutDataLink;
